<template>
  <div>
    <a class="btn btn-primary" href="#" @click="$router.go(-1)"><i class="fa fa-arrow-left"></i> 回上一頁</a>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>


    <h1>網頁文字</h1>
    <MyCkEditor v-model="datas.HtmlContent" height="600px" width="800px" ></MyCkEditor>
  </div>
</template>

<script>

/**

 **/

import MyCkEditor from "@/taylorCommon/component/MyCkEditor";
import apiAdmin from "@/taylorCommon/apiAdmin";
import adminUtil from "@/taylorCommon/adminUtil";

// import {
//   WebContent_QueryType_1_About,
// } from "./js/fireGodsDeclare";

export default {
  components: { MyCkEditor},
  //name: "contentEdit",
  data: function () {
    return {
      SystemId: "",
      isLoaded:false,
      isDataChange:false,
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{},
      datasTemplate:{
        HtmlContent:"",
        Files:[],
        Field01:"",
        Field02:"",
        Field03:"",
        Field04:"",
        Field05:"",
      },
      queryType:"",
    };
  },
  watch:{
    // datas: function(newValue, oldValue) {
    //   debugger // eslint-disable-line
    //   if (this.isLoaded){
    //     this.isDataChange = true;
    //   }
    // }
    // datas:{
    //   handler(val,oldValue) {
    //     if (this.isLoaded) {
    //       this.isDataChange = true;
    //     }
    //   },
    //   deep:true,
    // }
  },
  methods: {
    loadData() {
      let that = this;
      apiAdmin.api_admWebContent_QueryContent(this.queryType).then((data)=>{
        let dataApi=adminUtil.ParseJsonOrDefaultObjectWithTemplate(data.data.data,this.datasTemplate);

        that.datas = dataApi;
      })
    },

    submit(){
      apiAdmin.api_admWebContent_SaveContent(this.queryType,this.datas).then((data)=>{
        alert('儲存成功')
      })
    },
  },
  mounted() {
    this.queryType=this.$route.query.QueryType
    this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1000px;
}

</style>
